<template>
  <el-dialog title="节点管理" :visible.sync="visible_">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="名称">
        <el-input class="name" v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="描述">
        <el-input
          type="textarea"
          :rows="3"
          v-model="form.description"
        ></el-input>
      </el-form-item>
      <el-form-item class="buttons">
        <el-button type="primary" @click="onSubmit" :loading="saving"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
const defaultForm = {
  id: 0,
  name: "",
  description: ""
};
export default {
  name: "NodeCreateEditDialog",
  props: ["node"],
  data() {
    return {
      visible_: true,
      saving: false,
      form: this.node ? this.node : { ...defaultForm }
    };
  },
  watch: {
    visible_() {
      this.$emit("close");
      this.saving = false;
    }
  },
  methods: {
    onSubmit() {
      this.$emit("change", this.form);
      this.saving = true;
    }
  }
};
</script>

<style scoped lang="scss">
.name {
  max-width: 260px;
}
.buttons {
  display: flex;
  justify-content: flex-end;
  &.el-form-item {
    margin-bottom: unset;
  }
}
</style>
